<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Важная информация о работе Finch"
      @button-click="hideModal"
      @hidden="emit('hidden')"
      button-text="Понятно"
      :max-width="500"
  >
    <template #default>
        <p class="service-outage-modal__text mb-3">
            После масштабного сбоя в сервисах Яндекса платформа Finch работает нестабильно.
            Мы уже устраняем неполадки и делаем всё возможное, чтобы как можно скорее восстановить
            привычную работу сервиса.
        </p>
        <p class="service-outage-modal__text mb-3">
            <b>В качестве компенсации за возникшие неудобства мы бесплатно продлим доступ к платформе:</b><br />
            <b>Пользователям с действующей подпиской</b> — добавим 30 дней к текущему оплаченному периоду.
            Дата следующего списания автоматически перенесётся на 30 дней.<br />
            <b>Пользователям на пробном периоде</b> — продлим бесплатный доступ до 31 октября включительно.
        </p>
        <p class="service-outage-modal__text mb-3">
            Все изменения произойдут автоматически — никаких дополнительных действий не требуется.<br />
            Если у вас возникли вопросы, напишите нам на официальную почту службы поддержки:
            <a href="mailto:support@finch.study">support@finch.study</a>.<br />
            Спасибо за понимание и терпение!
        </p>
        <p class="service-outage-modal__text mb-0">
            Мы обязательно сообщим, когда работа платформы полностью восстановится.<br />
            С уважением,<br />
            <b>Команда Finch</b>
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
// Модалка о сбое в работе платформы (FINCH-2630). Чисто информационная:
// кнопка «Понятно» только закрывает окно, факт показа фиксирует хост по событию hidden.
import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
}>();

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.service-outage-modal__text {
    font-size: 14px;
}
</style>
